<template>
  <div
    :class="{
      'tm-calendar-cell--outdated': outdated,
      'tm-calendar-cell--current': current,
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    outdated: {
      type: Boolean,
    },
    current: {
      type: Boolean,
    },
  },
})
</script>

<style lang="scss" scoped>
.tm-calendar-cell {
  &--outdated {
    background-color: $lift;
  }

  &--current {
    position: relative;
    border-bottom: 1px solid $red;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -4px;
      left: 0;
      height: 7px;
      width: 7px;
      border-radius: 50%;
      background-color: $red;
    }
  }
}
</style>
